import '../styles/Primitives.scss';

export default function DialogActions({ children, className = '', ...props }) {
  return <div className={`ui-dialog-actions ${className}`.trim()} {...props}>{children}</div>;
}
